module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "bg-white rounded center p4 inline-block mt2"
  }, [_c('div', {
    staticClass: "fz32 light mt2"
  }, [_vm._v("Takk for besillingen!")]), _vm._v(" "), _c('div', {
    staticClass: "fz16 pt3 pb2"
  }, [_vm._v("\n      Din bestilling har blitt mottatt og vil bli behandlet så raskt som mulig.\n    ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary px3 py1",
    nativeOn: {
      "click": function($event) {
        _vm.viewOrder()
      }
    }
  }, [_vm._v("Se din ordre her")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea068e9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/shop/OrderComplete.vue
// module id = 649
// module chunks = 1